import { fakeTableList, schema } from "./parts";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { useLocation, useNavigate } from "react-router-dom";
import { httpAPI_ACC013 } from "./api/request";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { Box } from "@mui/material";
import { BusinessContext } from "../../context/businessContext";

/**
 * SCRR410001 退職手当金請求者の情報入力
 * @return SCRR410001 退職手当金請求者の情報入力
 */
const SCRR410001 = () => {
  const navigate = useNavigate();
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  const [name, setName] = useState<string>("");
  const [nameKana, setNameKana] = useState<string>("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const accessUrlId: any = queryParams.get("access_id");
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);

  useEffect(() => {
    let name = fakeTableList.find((item) => item.keyword === "name")!;
    name.onGetInputValue = (value: any) => {
      let fullName = value.lastName + "　" + value.firstName;
      setName(fullName);
    };

    let nameKana = fakeTableList.find((item) => item.keyword === "nameKana")!;
    nameKana.onGetInputValue = (value: any) => {
      let fullNameKana = value.lastName + " " + value.firstName;
      setNameKana(fullNameKana);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const handleSubmit = async (e: any) => {
    //業務チェック
    if (e.email !== e.emailConfirm) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0001E",
      });
    } else {
      setState({ ...state, errorMsgId: "" });
      submitEvent(e);
    }
  };

  const submitEvent = async (e: any) => {
    try {
      const res = await httpAPI_ACC013({
        transferCd: e.retirementMoneyRequestCd,
        name: name,
        kana: nameKana,
        birthday: e.birthday,
        email: e.email,
        accessUrlId: accessUrlId,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setBusinessState({
          ...businessState,
          job_81: {
            accessUrlId: accessUrlId,
            userId: res.userId,
            userProcessKuben: "0",
          },
        });
        setState({
          ...state,
          authInfo: {
            ...state?.authInfo,
            email: e.email, // 入出力項目.メールアドレス（機構連絡用）
          },
          errorMsgId: "",
        });
        navigate("/SCRR010001", {
          state: {
            userId: res.userId,
            accessUrlId: accessUrlId,
            userProcessKuben: "0",
          },
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRR410001PageForTest" className="tkSCRR410001">
      <TkFakeTable
        list={fakeTableList}
        ruleSchema={schema}
        submitButtonGroup={[{ submitButtonText: "登録" }]}
        onCheckAndSubmit={(e) => handleSubmit(e)}
      />
    </Box>
  );
};

export default SCRR410001;
